<template>
  <div>
    <z-fix-top keep-position class="fixtop" headerTaskbarBG="#F8F8F8">
      <z-nav-bar class="navbar" left-arrow style="background: #F8F8F8" @click-left="closePage">
      </z-nav-bar>
    </z-fix-top>
    <div class="wrapper">
      <div class="tips">
        <div class="title">举报完成</div>
      </div>
      <div class="tips">
        <div class="desc">
          <span>{{ reportDesc.text }}</span>
          <span v-if="reportDesc.show">
            <span>并可</span>
            <a @click="supplementReport"> 补充举报</a>
          </span>
        </div>
      </div>
      <ReportInfo :historyInfo="historyInfo" />
    </div>
    <z-loading v-if="loading" type="zz" size="60px" vertical class="message">正在加载</z-loading>
  </div>
</template>
<script>

import native from '@zz-common/native-adapter'
import { FixTop, NavBar, Loading } from '@zz-common/zz-ui'
import { getCaseTrackStatusByOrderId, getCaseTrackReportConfig } from '@api/resourceApi';
import ReportInfo from '../components/ReportInfo'
import { lego } from '@zz-common/lego'
import { queryParams, getCookie } from '@lib/utils';

const query = queryParams()

export default {
  name: 'superviseResult',
  data() {
    return {
      reportSource: query.reportSource || this.$route.query.reportSource,
      orderId: query.orderId || this.$route.query.orderId,
      historyInfo: {},
      reportTextMap: {
        doorRecycling: {
          1: '感谢您的反馈，如有疑问请联系：4006551800',
          2: '感谢您的反馈，我司工作人员将在7个工作日内审核举报信息并致电回访，请您注意接听电话！'
        },
        storeRecycling: {
          1: '感谢您的反馈，如有疑问请联系：010-83416704',
          2: '感谢您的反馈，我司工作人员将在7个工作日内审核举报信息并致电回访，请您注意接听010开头的电话！'
        }
      },
      reportDesc: { text: '', show: false },
      loading: false
    }
  },
  methods: {
    closePage() {
      native.close()
    },
    supplementReport() {
      native.skipToUrl({
        targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/supervise/commit?orderId=${this.orderId}&reportSource=${this.reportSource}&supply=1`,
        needClose: 1
      })
    },
    async init() {
      this.loading = true;
      const configRes = await getCaseTrackReportConfig()
      const { evidenceCount } = configRes[this.reportSource] || {};
      this.evidenceCount = evidenceCount
      const statusRes = await getCaseTrackStatusByOrderId({
        reportSource: this.reportSource,
        orderId: this.orderId
      })
      this.historyInfo = statusRes;
      const type = this.reportTextMap[this.reportSource] || {};
      const { finish } = this.historyInfo;
      if (finish == 'true' || this.historyInfo.supplementCount >= (+this.evidenceCount || 0)) { //已完结
        this.reportDesc = { text: type[1], show: false }
      } else {
        this.reportDesc = { text: type[2], show: true }
      }
      this.loading = false;
      lego.send({
        pagetype: 'SUPERVISE',
        actiontype: 'ENTRY_RESULT_PAGE',
        backup: {
          uid: getCookie('uid')
        }
      })
    }
  },
  created() {
    this.init()
  },
  components: {
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop,
    'z-loading': Loading,
    ReportInfo
  }
}
</script>

<style scoped lang="less">
@import 'index.less';
</style>
